import styled from "@emotion/styled";
import { Container } from "@mui/material";
import MKBox from "components/MKBox";

export const StyledBenefitsOfMusicAndMentalHealthSectionContainer = styled(Container)(({ theme }) => ({
  paddingBlock: "4rem",

  [theme.breakpoints.up("lg")]: {
    paddingBlock: "6rem",
  },
}));

export const StyledBenefitsCardsContainer = styled(MKBox)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "2rem",
}));
